import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = ["src"]
const _hoisted_3 = ["title"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_block_handle_menu = _resolveComponent("block-handle-menu")

  return (_openBlock(), _createElementBlock("figure", {
    class: _normalizeClass($options.figureClass)
  }, [
    ($props.type === 'image')
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: $props.src,
          alt: $props.altText,
          style: _normalizeStyle($options.imgStyle)
        }, null, 12 /* STYLE, PROPS */, _hoisted_1))
      : (_openBlock(), _createElementBlock("span", {
          key: 1,
          class: _normalizeClass([$data.C.embed, $data.C.embed16x9])
        }, [
          _createElementVNode("video", {
            class: _normalizeClass($data.C.embedItem),
            src: $props.src,
            controls: ""
          }, null, 10 /* CLASS, PROPS */, _hoisted_2)
        ], 2 /* CLASS */)),
    ($props.link)
      ? (_openBlock(), _createElementBlock("span", {
          key: 2,
          class: "gfu-editor-block__link-indicator",
          title: `Links to: ${$props.link}`,
          "data-qa": "editor-media:LinkIndicator"
        }, [
          _createVNode(_component_base_icon, { name: "link" })
        ], 8 /* PROPS */, _hoisted_3))
      : _createCommentVNode("v-if", true),
    ($props.caption)
      ? (_openBlock(), _createElementBlock("figcaption", {
          key: 3,
          class: _normalizeClass($data.C.blockCaption)
        }, _toDisplayString($props.caption), 3 /* TEXT, CLASS */))
      : _createCommentVNode("v-if", true),
    ($props.editable)
      ? (_openBlock(), _createBlock(_component_block_handle_menu, {
          key: 4,
          "can-edit": true,
          onMoveUp: _cache[0] || (_cache[0] = $event => (_ctx.$emit('move-up'))),
          onMoveDown: _cache[1] || (_cache[1] = $event => (_ctx.$emit('move-down'))),
          onEdit: _cache[2] || (_cache[2] = $event => (_ctx.$emit('edit'))),
          onRemove: _cache[3] || (_cache[3] = $event => (_ctx.$emit('remove'))),
          onAddBelow: _cache[4] || (_cache[4] = $event => (_ctx.$emit('add-below')))
        }))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}